/** * @name: use-sel-main-panel * @author: weiyong * @date: 2023-02-21 16:01 *
@description：use-sel-main-panel * @update: 2023-02-21 16:01 */
<template>
  <div class="use-sel-main-panel">
    <div class="tab-panel" v-if="showSearchDiv">
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="searchPanel" :tab="t('搜索')" />
      </a-tabs>
      <search-user-panel-body
        :alreadySelUsers="alreadySelUsers"
        @selItemRecord="selItemRecord"
        :searchUserList="searchUserList"
      />
    </div>
    <div class="tab-panel" v-if="!showSearchDiv">
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane v-if="configs.pingyingUser!==false&&!account" key="userList" :tab="t('成员')" />
        <a-tab-pane v-if="configs.orgUser!==false" key="orgUser" :tab="t('组织成员')" />
        <a-tab-pane v-if="configs.roleUser!==false&&!account" key="roleUser" :tab="t('角色成员')" />
        <!--       <a-tab-pane key="岗位成员" tab="岗位成员"></a-tab-pane>-->
        <!--       <a-tab-pane key="群组成员" tab="群组成员"></a-tab-pane>-->
      </a-tabs>
      <!--用户panel-->
      <user-panel-body
        v-if="!account && activeKey === 'userList'"
        :roleName="roleName"
        :aptitudeCode="aptitudeCode"
        :alreadySelUsers="alreadySelUsers"
        ref="userListRef"
        @selItemRecord="selItemRecord"
      />
      <!--机构用户panel-->
      <org-panel-body
        :alreadySelUsers="alreadySelUsers"
        ref="accountBodyRef"
        :multiple="multiple"
        @selItemRecord="selItemRecord"
        v-if="activeKey === 'orgUser'"
      />
      <!--角色用户panel-->
      <role-panel-body
        v-if="!account && activeKey === 'roleUser'"
        :roleName="roleName"
        :alreadySelUsers="alreadySelUsers"
        :multiple="multiple"
        @selItemRecord="selItemRecord"
      />
    </div>
    <div class="alread-sel-panel">
      <div class="header-bar w100b">
        <div>
          {{ t("已选择") }}（<span>{{ alreadySelUsers.length }}</span
          >/<span>{{ multipleCount }}</span
          >）
        </div>
      </div>
      <already-sel-user-panel
        @delRecord="delRecord"
        :alreadySelUsers="alreadySelUsers"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: {},
  name: "use-sel-main-panel",
});
</script>

<script lang="ts" setup>
import RolePanelBody from "../panelBody/role-panel-body.vue";
import UserPanelBody from "../panelBody/user-panel-body.vue";
import OrgPanelBody from "../panelBody/org-panel-body.vue";
import SearchUserPanelBody from "../panelBody/search-user-panel-body.vue";
import AlreadySelUserPanel from "./already-sel-user-panel.vue";
import { Tabs as aTabs, TabPane as aTabPane } from "ant-design-vue";
import { useSelUser } from "../hooks/useSelUser";

const { t } = useI18n();
const props = defineProps({
  account: {
    type: Boolean,
    default: false,
  },
  roleName:{},
  selUserRecords: {},
  configs:{},
  multiple: {},
  aptitudeCode: '',
  searchUserList: {},
  showSearchDiv: {},
});

const {configs, showSearchDiv, multiple, roleName, aptitudeCode, selUserRecords }: any = toRefs(props);
//选人hooks
const {
  alreadySelUsers,
  getSelUsers,
  selItemRecord,
  delRecord,
  multipleCount,
  clearSelUsers,
} = useSelUser(multiple, selUserRecords);

const accountBodyRef: any = ref(null);
const userListRef:any=ref(null);
const flushOrgList = ({ key }) => {
  //如果当前tab是机构
  if(unref(activeKey)==='orgUser'){
    accountBodyRef.value?.flushOrgList({ key });
  }
  //如果是成员
  if(unref(activeKey)==='userList'){
    userListRef.value?.flushUserList({key});
  }

};

const activeKey = ref("userList");
if(unref(configs).orgUser===false){
  activeKey.value='userList';
}
if(unref(configs).pingyingUser===false){
  activeKey.value='roleUser';
}

/**
 * 监听是查询div 还是 tab
 */
watch(showSearchDiv, (val) => {
  if (val) {
    activeKey.value = "searchPanel";
  } else {
    activeKey.value = "orgUser";
  }
});

defineExpose({ getSelUsers, flushOrgList,clearSelUsers });
</script>

<style type="text/css" lang="less">
.use-sel-main-panel {
  display: flex;
  overflow: hidden;
  /* 与左侧 tab 内容区高度对齐：tabs ≈48px + (80vh - 130px) */
  height: calc(80vh - 82px);
  border-bottom: 1px solid #dfdfdf;

  .tab-panel {
    width: 65%;
    border-right: 1px solid #dfdfdf;
    overflow: hidden;

    .ant-tabs-top > .ant-tabs-nav, .ant-tabs-bottom > .ant-tabs-nav, .ant-tabs-top > div > .ant-tabs-nav, .ant-tabs-bottom > div > .ant-tabs-nav{
      margin-bottom: 0;
    }
  }

  .alread-sel-panel {
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .header-bar {
      flex-shrink: 0;
      background-color: #f1f3f4;
      padding: 12px 12px;
      display: flex;
      justify-content: space-between;
    }

    .already-sel-user-panel {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
    }
  }
}
</style>
